import { FC, PropsWithChildren } from 'react';

import DeviceIdentifierContext from '@/context/DeviceIdentifierContext/DeviceIdentifierContext';
import useGetDeviceIdentifier from '@/hooks/api/device-identifiers/useGetDeviceIdentifier';

const DeviceIdentifierContextProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const { Provider } = DeviceIdentifierContext;
  const { data, isPending } = useGetDeviceIdentifier();

  return (
    <Provider value={{ udiDi: data?.udiDi, udiPi: data?.udiPi, isPending }}>
      {children}
    </Provider>
  );
};

export default DeviceIdentifierContextProvider;
